import React from 'react'
import { Icon } from '@iconify/react';

function NetworkPart2(props) {

    const {
        inchargeNameNetwork, setInchargeNameNetwork,
        inchargeEmailNetwork, setInchargeEmailNetwork,
        inchargeDesignationNetwork, setInchargeDesignationNetwork,
        certInNetworkDownloading, setCertInNetworkownloading,
        certInNetworkVulnerabilities, setCertInNetworkVulnerabilities,
        certInNetworkVulCount, setCertInNetworkVulCount,
        certInNetworkCritical, setCertInNetworkCritical,
        certInNetworkHigh, setCertInNetworkHigh,
        certInNetworkMedium, setCertInNetworkMedium,
        certInNetworkLow, setCertInNetworkLow,
        handleCertInNetworkDownload, handlePrevPage, handleNextPage, handleCertInNetworkCancel
    } = props

    return (
        <div className='report_part2'>
            <div className='report_part2_content'>
                <div className='report_part2_heading'>
                    <h1>Part 2 Network Cert-In Format</h1>
                </div>
                <div className='report_part2_input'>
                    <div className='report_part2_leftside'>

                        <div className='report_input'>
                            <div style={{ display: "flex" }}>
                                <label>Organization Incharge Name</label>
                            </div>
                            <input type='text' placeholder='Organization Incharge Name' value={inchargeNameNetwork} onChange={(e) => setInchargeNameNetwork(e.target.value)} />
                        </div>

                        <div className='report_input'>
                            <div style={{ display: "flex" }}>
                                <label>Organization Incharge Email</label>
                            </div>
                            <input type='email' placeholder='Organization Incharge Email' value={inchargeEmailNetwork} onChange={(e) => setInchargeEmailNetwork(e.target.value)} />
                        </div>

                        <div className='report_input'>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <label>Organization Incharge Designation</label>
                                <p style={{ fontSize: "11px", textAlign: "left", marginBottom: "3px", color: "#2E89E4" }}>If not applicable enter N/A</p>

                            </div>
                            <input type='text' placeholder='Organization Incharge Designation' value={inchargeDesignationNetwork} onChange={(e) => setInchargeDesignationNetwork(e.target.value)} />
                        </div>

                        <div className='report_input'>
                            <div style={{ display: "flex" }}>
                                <label>No. of vulnerabilities </label>
                            </div>

                            <input type='text' placeholder='Count Of Vulnerabilities' value={certInNetworkVulCount} onChange={(e) => setCertInNetworkVulCount(e.target.value)} />
                            <p style={{ fontSize: "11px", textAlign: "left", color: "#2E89E4", marginTop: "5px", marginBottom: "5px" }}>Example: Twenty(20)</p>

                        </div>



                    </div>

                    <div className='report_part1_rightside'>

                        <div className='report_input'>
                            <h3 style={{ marginTop: "4px" }}>
                                Severity risk rating </h3>
                            <table style={{ width: "250px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: "70px" }}>Severity level</th>
                                        <th style={{ width: "70px" }}>Frequency</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ width: "70px" }}>Critical</td>
                                        {/*<td style={{ width: "70px" }}><input type='number' style={{ width: "70px", height: "10px", marginBottom: "2px" }} value={certInNetworkCritical} onChange={(e) => setCertInNetworkCritical(e.target.value)} /></td>
                                        <td className="number_cell">
                                            <div className="number-control">
                                                <button className="number-btn" onClick={() =>
                                                    setCertInNetworkCritical((prev) => Math.max(0,parseInt(prev || 0) - 1))
                                                }>
                                                    −
                                                </button>
                                                <input
                                                    type="number"
                                                    value={certInNetworkCritical}
                                                    onChange={(e) => setCertInNetworkCritical(e.target.value)}
                                                    className="number-input"
                                                />

                                                <button className="number-btn" onClick={() =>
                                                    setCertInNetworkCritical((prev) => parseInt(prev || 0) + 1)
                                                }>
                                                    +
                                                </button>
                                            </div>
                                        </td>*/}
                                        <td style={{ width: "70px", backgroundColor: "#f0f0f0" }}>
                                            <div className="content-box">
                                                <button
                                                    type="button"
                                                    className='decrease_button'
                                                    onClick={() => setCertInNetworkCritical(prev => Math.max(0, Number(prev) - 1))}
                                                >−</button>
                                                <input
                                                    type="number"
                                                    className="input"
                                                    style={{ width: "55px", height: "10px", margin: "0 2px", backgroundColor: "transparent", textAlign: "center" }}
                                                    value={certInNetworkCritical}
                                                    onChange={(e) => setCertInNetworkCritical(e.target.value)}
                                                />
                                                <button
                                                    type="button"
                                                    className='increase_button'
                                                    onClick={() => setCertInNetworkCritical(prev => Number(prev) + 1)}
                                                >+</button>
                                            </div>
                                        </td>

                                    </tr>
                                    <tr>
                                        <td style={{ width: "70px" }}>High</td>
                                        {/*<td style={{ width: "70px" }}><input type='number' style={{ width: "70px", height: "10px", marginBottom: "2px" }} value={certInNetworkHigh} onChange={(e) => setCertInNetworkHigh(e.target.value)} /></td>*/}
                                        <td style={{ width: "70px", backgroundColor: "#f0f0f0" }}>
                                            <div className="content-box">
                                                <button
                                                    type="button"
                                                    className='decrease_button'
                                                    onClick={() => setCertInNetworkHigh(prev => Math.max(0, Number(prev) - 1))}
                                                >−</button>
                                                <input
                                                    type="number"
                                                    className="input"
                                                    style={{ width: "55px", height: "10px", margin: "0 2px", backgroundColor: "transparent", textAlign: "center" }}
                                                    value={certInNetworkHigh}
                                                    onChange={(e) => setCertInNetworkHigh(e.target.value)}
                                                />
                                                <button
                                                    type="button"
                                                    className='increase_button'
                                                    onClick={() => setCertInNetworkHigh(prev => Number(prev) + 1)}
                                                >+</button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "70px" }}>Medium</td>
                                        {/*<td style={{ width: "70px" }}><input type='number' style={{ width: "70px", height: "10px", marginBottom: "2px" }} value={certInNetworkMedium} onChange={(e) => setCertInNetworkMedium(e.target.value)} /></td>*/}
                                        <td style={{ width: "70px", backgroundColor: "#f0f0f0" }}>
                                            <div className="content-box">
                                                <button
                                                    type="button"
                                                    className='decrease_button'
                                                    onClick={() => setCertInNetworkMedium(prev => Math.max(0, Number(prev) - 1))}
                                                >−</button>
                                                <input
                                                    type="number"
                                                    className="input"
                                                    style={{ width: "55px", height: "10px", margin: "0 2px", backgroundColor: "transparent", textAlign: "center" }}
                                                    value={certInNetworkMedium}
                                                    onChange={(e) => setCertInNetworkMedium(e.target.value)}
                                                />
                                                <button
                                                    type="button"
                                                    className='increase_button'
                                                    onClick={() => setCertInNetworkMedium(prev => Number(prev) + 1)}
                                                >+</button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "70px" }}>Low</td>
                                        {/*<td style={{ width: "70px" }}><input type='number' style={{ width: "70px", height: "10px", marginBottom: "2px" }} value={certInNetworkLow} onChange={(e) => setCertInNetworkLow(e.target.value)} /></td>*/}
                                        <td style={{ width: "70px", backgroundColor: "#f0f0f0" }}>
                                            <div className="content-box">
                                                <button
                                                    type="button"
                                                    className='decrease_button'
                                                    onClick={() => setCertInNetworkLow(prev => Math.max(0, Number(prev) - 1))}
                                                >−</button>
                                                <input
                                                    type="number"
                                                    className="input"
                                                    style={{ width: "55px", height: "10px", margin: "0 2px", backgroundColor: "transparent", textAlign: "center" }}
                                                    value={certInNetworkLow}
                                                    onChange={(e) => setCertInNetworkMedium(e.target.value)}
                                                />
                                                <button
                                                    type="button"
                                                    className='increase_button'
                                                    onClick={() => setCertInNetworkLow(prev => Number(prev) + 1)}
                                                >+</button>
                                            </div>
                                        </td>

                                    </tr>

                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>

                <div className='report_part1_button'>
                    <Icon icon="stash:arrow-left-light" onClick={handlePrevPage} className="prev_icon" />

                    {/*<button style={{ fontSize: "13px", marginRight: "20px" }} onClick={handlePrevPage}>Prev</button>*/}
                    <button className='part1_cancel_button' onClick={handleCertInNetworkCancel}>Cancel</button>
                    {/* <button className='part2_draft_button' onClick={handleDraftClick} disabled={disableDraft}>Draft</button> */}
                    <button className='part1_upload_button' onClick={handleCertInNetworkDownload}>Download</button>
                    {/*<button style={{ fontSize: "13px", marginLeft: "20px" }} onClick={handleNextPage} >Next</button>*/}
                    <Icon icon="stash:arrow-right-light" onClick={handleNextPage} className="next_icon" />

                </div>

            </div>

        </div>
    )
}

export default NetworkPart2
